import { render, staticRenderFns } from "./form-packaging.vue?vue&type=template&id=2276ec8d&"
import script from "./form-packaging.vue?vue&type=script&lang=js&"
export * from "./form-packaging.vue?vue&type=script&lang=js&"
import style0 from "./form-packaging.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports